import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Grid2, MenuItem, Select, Skeleton, Typography, useTheme } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import { useGetChangeByContractorQuery } from "store/slices/apis/claimsAndChangeOrderDashboardSlice";
import { useParams } from "react-router-dom";
import ClaimsandChangeOrderPopup from "./ClaimsPopup";
import ChangeOrderPopup from "./ChangeOrderPopup";

const ChangeOrderByContractor = () => {
    const { projectId } = useParams();
    const theme = useTheme();
    const [popupData, setPopupData] = useState(null);
    const [open, setOpen] = useState(false);
    const { data, isLoading } = useGetChangeByContractorQuery({ projectId });

    const [chartData, setChartData] = useState({
        categories: [],
        series: [],
    });
    useEffect(() => {
        if (data?.data && Array.isArray(data?.data)) {
            const categories = data?.data?.map(item => item?.contractor);
            const series = data?.data.map(item => ({
                y: item?.value,
                name: item?.contractor,
                color: "#415385",
            }));
            setChartData({ categories, series });
        }
    }, [data]);


    const chartOptions = {
        chart: {
            type: 'bar',
            marginLeft: 200,
        },
        title: {
            text: "",
            align: "left",
            style: {
                fontSize: "14px",
                fontWeight: "bold",
                color: "#21325B",
            },
        },
        xAxis: {
            lineWidth: 0,
            offset: 50,
            title: {
                text: 'Contractors',
                rotation: 0,
                align: 'high',
                offset: 0,
                x: 0,
                y: -15,
                style: {
                    fontSize: '14px',
                    lineHeight: '100%',
                    fontWeight: 400,
                    letterSpacing: '-0.4px',
                    color: '#000000',
                    opacity: "0.5"
                }
            },
            categories: chartData?.categories,
            labels: {
                y: 10,
                align: 'right',
                style: {
                    fontSize: '14px',
                    lineHeight: '100%',
                    fontWeight: 500,
                    letterSpacing: '-0.4px',
                    color: '#182A4E',
                    whiteSpace: 'nowrap',
                },
            },
        },
        yAxis: {
            min: 0,
            opposite: true,
            title: {
                text: "",
            },
            labels: {
                format: '{value}',
                style: {
                    fontSize: '12px',
                    lineHeight: '100%',
                    fontWeight: 500,
                    letterSpacing: '0%',
                    color: '#414D55',
                    opacity: "0.5"
                },
            },
            gridLineWidth: 0,
            lineWidth: 1,
        },
        plotOptions: {
            bar: {
                pointPadding: 0.1,
                groupPadding: 0.1,
                minPointLength: 5,
            },
        },
        colors: ["#415385"],
        series: [
            {
                name: "Change Order by Contractor",
                data: chartData?.series,
                point: {
                    events: {
                        click: function () {
                            setPopupData({
                                contractor: this.name,
                                value: this.y,
                            });
                            setOpen(true);
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    inside: false,
                    align: "left",
                    formatter: function () {
                        return this.y;
                    },
                    style: {
                        color: '#000000',
                        fontSize: '14px',
                        fontWeight: 500,
                        textOutline: 'none',
                        letterSpacing: "-0.4px",
                        lineHeight: "100%"
                    }
                },
            }
        ],
        credits: {
            enabled: false,
        },
        legend: {
            enabled: false,
            align: "left",
            itemDistance: 40,
            alignColumns: false,
            reversed: true,
            x: 50,
            y: 0
        },
        tooltip: {
            enabled: true,
        },
    };

    return (
        <Box sx={{ backgroundColor: "white", border: "1px solid #D8D8D8", borderRadius: "12px", height: "100%" }}>
            <Grid2 container>
                <Box sx={{ paddingLeft: "17px" }}>
                    <Typography variant="h6" sx={{ mb: 1, color: `${theme?.customSettings?.themeColor}`, fontWeight: "500", fontSize: '18px', paddingTop: "20px", lineHeight: "100%", letterSpacing: "0.4px" }}>
                        Change Order by Contractor
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2, color: "#182A4E80", whiteSpace: { xs: "normal", md: "nowrap" } }}>
                        Analyze contractor-specific change orders to monitor cost drivers and contractual performance
                    </Typography>
                </Box>
                {/* <Grid2 size={{ xs: 12, md: 6 }}>
                    <Box sx={{ width: '100%', display: "flex", justifyContent: 'end' }}>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            value={10}
                            IconComponent={IoIosArrowDown}
                            sx={{
                                backgroundColor: '#E8E8E8',
                                '& .MuiOutlinedInput-input': {
                                    padding: '5px 15px'
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none'
                                }
                            }}
                        >
                            <MenuItem value={10}>Value</MenuItem>
                        </Select>
                    </Box>
                </Grid2> */}
            </Grid2>
            <Box sx={{ paddingLeft: "10px", marginTop: "30px" }}>
                {isLoading ? (
                    <Skeleton variant="rectangular" height={300} animation="wave" />
                ) : (chartData.series.length === 0 ? (
                    <Box
                        sx={{
                            height: 300,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#999',
                            fontSize: 16,
                        }}
                    >
                        No data available to display the chart.
                    </Box>
                ) : (
                    <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                ))}
            </Box>
            {open && (() => {
                return (
                    <ChangeOrderPopup title={'Change Order by Contractor'} value={popupData?.contractor} status={'changeOrderByContractor'} onOpen={open} onClose={() => setOpen(false)} />
                )
            })()}
        </Box>
    );
};

export default ChangeOrderByContractor;
